/* Copy-to-clipboard for the two lab codes.

   Typing an eleven-digit certificate number by hand is where people give up, so
   each code gets a copy button. The button is progressive: if the clipboard API
   is unavailable the number is still printed on screen to read.
*/
(function () {
  const status = document.querySelector('[data-copy-status]');

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.dbp-verify__copy');
    if (!btn) return;

    const value = btn.dataset.copy;
    if (!value) return;

    let ok = false;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        ok = true;
      } else {
        // Older mobile browsers: the deprecated path still works over http.
        const ta = document.createElement('textarea');
        ta.value = value;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
        document.body.appendChild(ta);
        ta.select();
        ok = document.execCommand('copy');
        ta.remove();
      }
    } catch (_) {
      ok = false;
    }

    const label = btn.querySelector('.dbp-verify__copy-text');
    const original = label ? label.textContent : '';

    if (ok) {
      btn.classList.add('is-copied');
      if (label) label.textContent = 'Copied';
      if (status) status.textContent = value + ' copied';
      clearTimeout(btn._t);
      btn._t = setTimeout(() => {
        btn.classList.remove('is-copied');
        if (label) label.textContent = original;
        if (status) status.textContent = '';
      }, 2000);
    } else if (status) {
      status.textContent = 'Could not copy — the number is shown on screen.';
    }
  });
})();
